// NPM Imports
import React, { Component, Fragment } from "react";

// Components Imports
import RedoButton from "./RedoButton";
import UndoButton from "./UndoButton";
import InlineButtons from "./InlineButtons";
import ListButtons from "./ListButtons";
import HeaderButtons from "./HeaderButtons";
// import NormalTextButton from "./NormalTextButton";
import AlignButtons from "./AlignButtons";
import IdentButtons from "./IdentButtons";
import DynamicFieldButton from "./DynamicFieldButton";
import AddNote from "./AddNote";
import HyperlinkButton from "./HyperlinkButton";
import CustomColor from "./CustomColor";
import CustomSize from "./CustomSize";
import CustomFontStyle from "./CustomFontStyle";

// Internal Imports
import { DOCUMENTS } from "../../constants";
import {
  checkEmptySelection,
  checkSelectedTextHasEntity,
} from "../../utils/draftUtils";

// Destructuring
const { COMPONENT_FEATURE, DRAFT_ENTITY } = DOCUMENTS;

class RevvToolBar extends Component {
  state = {
    activeToolbarDropDown: null,
  };

  componentDidUpdate = (prevProps, nextProps) => {
    if (
      nextProps.activeToolbarDropDown === "FONT_COLOR" &&
      this.state.activeToolbarDropDown !== "FONT_COLOR"
    ) {
      this.props.handleCustomColorDropDownOpen(false, true);
    }
  };

  isNotesAllowed = (editorState, mode) => {
    if (!COMPONENT_FEATURE[mode].addNote) {
      return false;
    }
    if (checkEmptySelection(editorState)) {
      return false;
    }
    if (checkSelectedTextHasEntity(editorState, DRAFT_ENTITY.NOTES)) {
      return false;
    }
    return true;
  };

  isDynamicFieldAllowed = (editorState, mode) => {
    if (!COMPONENT_FEATURE[mode].dynamicFieldButton) {
      return false;
    }
    if (checkEmptySelection(editorState)) {
      return false;
    }
    if (checkSelectedTextHasEntity(editorState, DRAFT_ENTITY.DYNAMICFIELD)) {
      return false;
    }
    return true;
  };

  isHyperLinkAllowed = (editorState, mode) => {
    if (!COMPONENT_FEATURE[mode].hyperlinkButton) {
      return false;
    }
    if (checkEmptySelection(editorState)) {
      return false;
    }
    return true;
  };

  _toogleToolbarDropDown = type => {
    this.setState({
      activeToolbarDropDown: type,
    });
  };

  render() {
    const {
      externalProps,
      mode,
      component,
      addNote,
      editorState,
      handleUndo,
      handleRedo,
      handleBIUButtonClick,
      handleListButton,
      handleHeaderButton,
      handleNormalText,
      handleAlignment,
      handleIndent,
      highlightSelection,
      removeHighlightSelection,
      getEditorState,
      showHyperlinkBox,
      closeHyperlinkBox,
      isSeparateToolbar,
      fontFamilyUpdate,
    } = this.props;
    return (
      <div id="draft-custom-toolbar" className="revvtoolbar-wrapper">
        {/* 1. Undo Toolbar button */}
        {isSeparateToolbar && COMPONENT_FEATURE[mode].allowUndo && (
          <UndoButton
            data-test="revvtoolbar-undo-button"
            {...externalProps}
            section={component}
            mode={mode}
            handleUndo={handleUndo}
          />
        )}

        {/* 2. Redo Toolbar button */}
        {isSeparateToolbar && COMPONENT_FEATURE[mode].allowUndo && (
          <RedoButton
            data-test="revvtoolbar-redo-button"
            {...externalProps}
            section={component}
            mode={mode}
            handleRedo={handleRedo}
          />
        )}

        {editorState && component && (
          <Fragment>
            {isSeparateToolbar && (
              <div className="line-divide">
                <span className="line">|</span>
              </div>
            )}
            {/* 8. Header Toolbar buttons ex: H1, H2, H3 & H4 */}
            <HeaderButtons
              data-test="revvtoolbar-header-buttons"
              {...externalProps}
              editorState={editorState}
              handleHeaderButton={handleHeaderButton}
              handleNormalText={handleNormalText}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
            />

            {/* 6. Custom Font Family INline Toolbar button */}
            <CustomFontStyle
              externalProps={externalProps}
              editorState={editorState}
              fontFamilyUpdate={fontFamilyUpdate}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
              metaData={this.props.metaData}
              saveMetaData={this.props.saveMetaData}
            />
            <div className="line-divide">
              <span className="line">|</span>
            </div>
            {/* 4. Custom Font Size Inline Toolbar button */}
            <CustomSize
              externalProps={externalProps}
              editorState={editorState}
              sizeUpdate={handleBIUButtonClick}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
              metaData={this.props.metaData}
              saveMetaData={this.props.saveMetaData}
            />
            <div className="line-divide">
              <span className="line">|</span>
            </div>
            {/* 3. Inline Toolbar buttons ex: BOLD, ITALIC & UNDERLINE */}
            <InlineButtons
              data-test="revvtoolbar-inline-buttons"
              externalProps={externalProps}
              editorState={editorState}
              handleButtonClick={handleBIUButtonClick}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
              metaData={this.props.metaData}
            />
            <CustomColor
              externalProps={externalProps}
              editorState={editorState}
              fontColorUpdate={handleBIUButtonClick}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
              preventEditorToDeactivate={this.props.preventEditorToDeactivate}
              handleCustomColorDropDownOpen={
                this.props.handleCustomColorDropDownOpen
              }
              toolbarCustomColorDropdownRef={
                this.props.toolbarCustomColorDropdownRef
              }
              metaData={this.props.metaData}
              saveMetaData={this.props.saveMetaData}
            />
            <div className="line-divide">
              <span className="line">|</span>
            </div>

            {/* 10. Align Toolbar buttons ex: Left/Center/Right align */}
            <AlignButtons
              data-test="revvtoolbar-align-buttons"
              {...externalProps}
              editorState={editorState}
              handleAlignment={handleAlignment}
              toogleToolbarDropDown={this._toogleToolbarDropDown}
              activeToolbarDropDown={this.state.activeToolbarDropDown}
            />
            <div className="line-divide">
              <span className="line">|</span>
            </div>

            {/* 7. List Toolbar buttons ex: Ordered/Unordered List */}
            <ListButtons
              data-test="revvtoolbar-list-buttons"
              {...externalProps}
              editorState={editorState}
              handleNormalText={handleNormalText}
              handleListButton={handleListButton}
            />
            <div className="line-divide">
              <span className="line">|</span>
            </div>
            {/* 11. Ident Toolbar buttons ex: Indent/Outdent */}
            <IdentButtons
              data-test="revvtoolbar-ident-buttons"
              {...externalProps}
              handleIndent={handleIndent}
            />

            <div className="line-divide">
              <span className="line">|</span>
            </div>

            {/* 12. Add Hyperlink Toolbar button */}
            {this.isHyperLinkAllowed(editorState, mode) && (
              <HyperlinkButton
                data-test="revvtoolbar-hyperlink-button"
                externalProps={externalProps}
                component={component}
                editorState={editorState}
                getEditorState={getEditorState}
                showHyperlinkBox={showHyperlinkBox}
                closeHyperlinkBox={closeHyperlinkBox}
              />
            )}

            {/* 13. Add Note Toolbar button */}
            {this.isNotesAllowed(editorState, mode) && (
              <AddNote
                {...externalProps}
                component={component}
                addNote={addNote}
                editorState={editorState}
                highlightSelection={highlightSelection}
                removeHighlightSelection={removeHighlightSelection}
              />
            )}

            {/* 14. Add DynamicField Toolbar button */}
            {this.isDynamicFieldAllowed(editorState, mode) && (
              <DynamicFieldButton
                data-test="revvtoolbar-dynamic-field-button"
                {...externalProps}
                component={component}
                editorState={editorState}
                highlightSelection={highlightSelection}
                removeHighlightSelection={removeHighlightSelection}
              />
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default RevvToolBar;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/RevvToolBar.js